import { api } from "common/api/api";

const getUserContactsLists = async () => {
  try {
    const path = "/users/user-contacts-lists";
    const res = await api.get(path);
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res.data;
  } catch(err) {
    console.error(err);
  }
};

const exportFeatures = async () => {
  try {
    const path = "/features/export";
    const res = await api.post(path, null, { responseType: "arraybuffer" });
    if (res.status !== 200 && res.status !== 201) {
      throw new Error(res);
    }
    return res;
  } catch(err) {
    console.error(err);
  }
};

export { getUserContactsLists, exportFeatures };
